export const buildQueryString = (params = {}) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    queryParams.set(key, String(value));
  });

  return queryParams.toString();
};

export const buildPagedListUrl = (endpoint, { page = 1, limit = 10, ...filters } = {}) => {
  const queryString = buildQueryString({ page, limit, ...filters });
  return queryString ? `${endpoint}?${queryString}` : endpoint;
};
